/** Base de traslados WMS hacia Flexy. baseURL de axios ya incluye /api. */
export const TRASLADOS_BASE_PATH = '/traslados'

export const TRASLADOS_LIST_PATH = TRASLADOS_BASE_PATH

export function trasladoByIdPath(id: number | string): string {
  return `${TRASLADOS_BASE_PATH}/${id}`
}

export function trasladoAnularPath(id: number | string): string {
  return `${TRASLADOS_BASE_PATH}/${id}/anular`
}

export function trasladoReenviarFlexyPath(id: number | string, force = false): string {
  return `${TRASLADOS_BASE_PATH}/${id}/reenviar-flexy?force=${force ? 'true' : 'false'}`
}
